/** Center-scoped ADMIN helpers (servicecategory from login / JWT). */

export function isCenterAdmin() {
  return localStorage.getItem("userrole") === "ADMIN";
}

function decodeTokenPayload() {
  try {
    const token = localStorage.getItem("token");
    if (!token) return {};
    const base64 = token.split(".")[1];
    if (!base64) return {};
    const json = atob(base64.replace(/-/g, "+").replace(/_/g, "/"));
    return JSON.parse(json);
  } catch {
    return {};
  }
}

export function getLoggedInServiceCategory() {
  const stored = localStorage.getItem("servicecategory");
  if (stored) return stored;
  return decodeTokenPayload().servicecategory || "";
}

export function getLoggedInServiceArea() {
  const stored = localStorage.getItem("servicearea");
  if (stored) return stored;
  return decodeTokenPayload().servicearea || "";
}
